__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/05adfc6/_next/";